module.exports = __webpack_public_path__ + "img/travel-deals-notifications.e8c7a7c7.svg";